import React from 'react'
import './Diet.css'

const Diet = () => {
  return (
    <div className="diet-container" id="diet">
        <div className="diet-header" style={{gap: '1rem'}}>
            <span className="stroke-text">Nutrition</span>
            <span>Meal Plan</span>
        </div>
        <span>Coming Soon!</span>
    </div>
  )
}

export default Diet
